// extracted by mini-css-extract-plugin
export default {"table":"Table_table__8tDJw","rows":"Table_rows__TZrlB"};